import { GET_TOAST } from '../actions'

const defaults = {
  toast: {
    __typename: 'Toast',
    type: null,
    message: null,
    duration: null,
    shouldDismiss: false
  }
}

const resolvers = {
  Mutation: {
    setToast: (_, { toast }, { cache }) => {
      const data = {
        toast: {
          __typename: 'Toast',
          ...defaults.toast,
          ...toast
        }
      }
      cache.writeData({ data })
      return null
    },
    setToastDismiss: (_, args, { cache }) => {
      const { toast: oldToast } = cache.readQuery({ query: GET_TOAST })
      const data = {
        toast: {
          __typename: 'Toast',
          ...oldToast,
          shouldDismiss: true
        }
      }
      cache.writeData({ data })
      return null
    },
    clearToast: (_, args, { cache }) => {
      const data = defaults
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
